import script from "./ArticleEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./ArticleEditor.vue?vue&type=script&setup=true&lang=js"

import "./ArticleEditor.vue?vue&type=style&index=0&id=391b7ec3&scoped=true&lang=css"
import "./ArticleEditor.vue?vue&type=style&index=1&id=391b7ec3&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-391b7ec3"]])

export default __exports__